import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CorrectIcon from '@material-ui/icons/DoneOutline';
import Button from '@material-ui/core/Button';
import { getResource } from '../../tools';
import './Jeopardy.scss';

const useStyles = makeStyles(theme => ({
  Jeopardy: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      maxHeight: '100%',
      overflow: 'auto',
    },
  },
  table: {
    padding: 20,
    background: 'linear-gradient(45deg, #316fc6 0%,#95d1ed 51%,#2b93e2 100%)',
    overflow: 'auto',
    '& p': {
      fontSize: 24,
      margin: '0.5em',
      fontWeight: 600,
      color: '#314e94',
      '& span': {
        color: '#fff',
        opacity: 0.7,
        fontWegith: 400,
        display: 'inline-block',
        border: '2px solid rgba(54, 101, 181, 0.52)',
        borderRadius: '50%',
        width: 80,
        height: 40,
        textAlign: 'center',
        boxShadow: '0 0 22px #fff',
        background: '#5a9fd8',
        textShadow: '0 0 3px rgb(59, 87, 168)',
      }
    },
  },
  thead: {
    '& th': {
      borderRadius: 5,
      border: '2px solid #03081f',
      color: '#b3edf9',
      fontWeight: 400,
      padding: 3,
      fontSize: '1em',
      lineHeight: 1.2,
      textShadow: '0 0 5px #2ed0f1',
      background: 'linear-gradient(to bottom, #1e5799 0%,#275fce 50%,#3e4fa0 100%)',
      width: '25%',
    },
  },
  cells: {
    '& td': {
      borderRadius: 5,
      color: '#b3edf9',
      fontWeight: 400,
      fontSize: '1em',
      lineHeight: 1.2,
      verticalAlign: 'middle',
      width: '25%',
    },
  },
  td: {
    border: '2px solid #03081f',
    color: '#b3edf9',
    textShadow: '0 0 5px #2ed0f1',
    cursor: 'pointer',
    padding: 6,
    background: 'linear-gradient(to bottom,  #1e5799 0%,#2989d8 50%,#3e4fa0 100%)',
    '&:hover': {
      animation: 'jp-glowing 1000ms infinite',
      animationFillMode: 'forwards',
      color: '#fff',
    },
  },
  correct: {
    border: '2px solid #03081f',
    color: '#b3edf9',
    textShadow: '0 0 5px #2ed0f1',
    background: 'linear-gradient(to bottom, #079b07 0%,#83c783 41%,#008a00 67%,#006d1d 100%) ',
  },
  question: {
    background: 'linear-gradient(45deg, #316fc6 0%,#95d1ed 51%,#2b93e2 100%)',
    borderRadius: 15,
    border: '3px solid #447aa2',
    padding: '30px 10px',
    boxShadow: '3px 3px 5px rgba(8, 60, 191, 0.52)',
    '& table': {
      width: '100%',
      borderSpacing: '8px',
    },
    '& th': {
      borderRadius: 20,
      border: '2px solid #2e3f8e21',
      color: '#d9f8ff',
      fontWeight: 400,
      padding: '20px 10px',
      lineHeight: 1.2,
      textShadow: '0 0 5px #2ed0f1',
      fontSize: 24,
      background: 'linear-gradient(45deg, #0d59c4 1%,#38b2ea 51%,#1763e8 100%)',
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)',
    },
    '& td': {
      borderRadius: 20,
      border: '1px solid rgba(0, 0, 0, 0.5)',
      borderTop: '1px solid rgba(255, 255, 255, 0.3)',
      borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
      color: '#ddf9ff',
      fontWeight: 400,
      padding: '15px 6px',
      fontSize: '1em',
      lineHeight: 1.2,
      textShadow: '0 0 5px #2ed0f1',
      cursor: 'pointer',
      background: 'linear-gradient(to bottom,  #1e5799 0%,#2989d8 50%,#3e4fa0 100%)',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
      width: '50%',
      '&:hover': {
        animation: 'jp-glowing 1000ms infinite',
        animationFillMode: 'forwards',
        color: '#fff',
      },
    },
    '& p': {
      color: '#fff',
      fontSize: 24,
      margin: '0.5em',
      opacity: 0.7,
      '& span': {
        display: 'inline-block',
        border: '2px solid rgba(54, 101, 181, 0.52)',
        borderRadius: '50%',
        width: 70,
        height: 40,
        textAlign: 'center',
        boxShadow: '0 0 22px #fff',
        background: '#5a9fd8',
        textShadow: '0 0 3px rgb(59, 87, 168)',
      }
    },
  },
  timeUp: {
    width: '100%',
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to bottom,  #1e5799 0%,#2989d8 50%,#3e4fa0 100%)',
    color: '#fff',
    borderRadius: 20,
  },
  results: {
    width: '100%',
    height: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to bottom,  #1e5799 0%,#2989d8 50%,#3e4fa0 100%)',
    color: '#fff',
    borderRadius: 20,
    '& button': {
      background: '#fff !important',
    },
    '& p': {
      marginTop: 0,
    },
    '& h3': {
      marginBottom: '0.25em',
    },
    '& h2': {
      margin: '0.2em 0',
      fontSize: 40,
      letterSpacing: 3,
    }
  },
  '@media(max-width: 850px)': {

  }
}));

const maxTime = 10;
let timeout1 = 0;
let timeout2 = 0;
let interval1 = 0;
let active = true;
let timeX = 0;

function TheWords(props) {
  const classes = useStyles();
  const [state, setState] = useState({ type: 'table' });
  const [data, setData] = useState(false);
  const [time, setTime] = useState(maxTime);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const refs = [];
  refs[0] = useRef(null);
  refs[1] = useRef(null);
  refs[2] = useRef(null);
  refs[3] = useRef(null);

  useEffect(() => {
    startStats(type);
    props.media.bgMusic();
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearInterval(interval1);
      props.media.stopBgMusic();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let fileName = exercise.dataUrl
    let idx = fileName.lastIndexOf('/');
    fileName = fileName.substr(idx + 1);
    idx = fileName.lastIndexOf('.');
    fileName = fileName.substr(0, idx) + '.json';
    const url = `Jeopardy/${fileName}`

    getResource(url)
      .then((response) => {
        const newData = formatData(response);
        setData(newData);
      }).catch(e => console.log(e));
  }, [exercise]);

  const drawQuestion = () => {
    const q = state.q;
    const { rate, id } = q;

    const ans = idx => {
      return q.answers[idx].text;
    }

    const check = idx => {
      action();
      if (!active) return;
      if (q.answers[idx].correct) {
        correct(idx);
      } else {
        incorrect(idx);
      }
    }

    const markCorrect = () => {
      action();
      const newData = cloneObj(data);
      const col = Math.floor(id / 5);
      const row = id - col * 5;
      newData.data[col].questions[row].correct = true;
      newData.points = newData.points + rate;
      if (isFinished(newData)) {
        newData.finished = true;
        finishExercise();
      }
      setData(newData);
    }

    const markIncorrect = () => {
      action();
      const newData = cloneObj(data);
      newData.points = newData.points - rate;
      setData(newData);
    }

    const correct = (idx) => {
      clearInterval(interval1);
      active = false;
      if (!refs[idx]?.current) return;
      refs[idx].current.classList?.add('jp-correct');
      props.media.success2();
      markCorrect();
      timeout1 = setTimeout(() => {
        props.media.applause();
      }, 1500);
      timeout2 = setTimeout(() => {
        active = true;
        if (!refs[idx]?.current) return;
        refs[idx].current.classList.remove('jp-correct');
        setState({ type: 'table' });
      }, 3000);
    }

    const isFinished = (data) => {
      let finished = true;
      data.data.forEach(col => {
        col.questions.forEach(q => {
          if (!q.correct) finished = false;
        });
      });
      return finished;
    }

    const incorrect = (idx) => {
      clearInterval(interval1);
      active = false;
      props.media.failure();
      if (!refs[idx]?.current) return;
      refs[idx].current.classList.add('jp-incorrect');
      markIncorrect();
      timeout1 = setTimeout(() => {
        props.media.uuu();
      }, 1000);
      timeout2 = setTimeout(() => {
        active = true;
        if (!refs[idx]?.current) return;
        refs[idx].current.classList.remove('jp-incorrect');
        setState({ type: 'table' });
      }, 3000);
    }

    return (
      <div className={classes.question}>
        <table>
          <thead>
            <tr>
              <th colSpan="2">{q.question}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td onClick={() => check(0)} ref={refs[0]}>{ans(0)}</td>
              <td onClick={() => check(1)} ref={refs[1]}>{ans(1)}</td>
            </tr>
            <tr>
              <td onClick={() => check(2)} ref={refs[2]}>{ans(2)}</td>
              <td onClick={() => check(3)} ref={refs[3]}>{ans(3)}</td>
            </tr>
          </tbody>
        </table>
        <p><span onClick={() => setState({ type: 'table' })} className={time > 3 ? '' : 'jp-almost-up'}>{time}</span></p>
      </div>
    );
  }

  const drawRow = (row) => {

    const timeUp = () => {
      setState({ type: 'time-up' });
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      props.media.uuu();
      timeout1 = setTimeout(() => {
        setState({ type: 'table' });
      }, 3000);
      const newData = cloneObj(data);
      newData.points = newData.points - 300;
      setData(newData);
    }

    const showQuestion = (q) => {
      action();
      setState({ type: 'question', q });
      setTime(maxTime);
      timeX = maxTime;
      interval1 = setInterval(() => {
        if (timeX === -1) {
          clearInterval(interval1);
          timeUp();
        } else {
          setTime(timeX--);
        }
      }, 1000);
    }

    const arr = [0, 1, 2, 3, 4].slice(0, data.data.length);
    return (
      <tr key={`row-${row}`} className={classes.cells}>
        {arr.map(cell => {
          const q = data.data[cell].questions[row];
          if (!q.correct) return <td key={`c${row}-${cell}`} onClick={() => showQuestion(q)} className={classes.td}>{q.rate}</td>
          return <td key={`c${row}-${cell}`} className={classes.correct}><CorrectIcon /></td>
        })}
      </tr>
    );
  }

  const drawQuiz = () => {
    return (
      <div className={classes.table}>
        <table>
          <thead>
            <tr className={classes.thead}>
              {data.data.map(sets => <th key={sets.category}>{sets.category}</th>)}
            </tr>
          </thead>
          <tbody>
            {[0, 1, 2, 3, 4].map(row => drawRow(row))}
          </tbody>
        </table>
        <p>Twój wynik</p>
        <p><span>{data.points}</span></p>
      </div>
    );
  }

  const drawTimeUp = () => {
    return (
      <div className={classes.timeUp}>
        <h3>Sorry, the time is up</h3>
      </div>
    );
  }

  const drawResults = () => {
    return (
      <div className={classes.results}>
        <div>
          <h3>Congratulations!!!</h3>
          <p>You've earned</p>
          <h2>{data.points}</h2>
          <p>Points</p>
          <p><Button color="secondary" onClick={close}>Close</Button></p>
        </div>
      </div>
    );
  }

  if (!data) return <h3 style={{ textAlign: 'center', color: '#999' }}>Pobieram dane ćwiczenia...</h3>

  return (
    <div className={classes.Jeopardy}>
      <div>
        {state.type === 'table' && !data.finished && drawQuiz()}
        {state.type === 'question' && drawQuestion()}
        {state.type === 'time-up' && drawTimeUp()}
        {state.type === 'table' && data.finished && drawResults()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

function cloneObj(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function formatData(response) {
  const rawData = [];
  response.quiz.zagadnienie.forEach(obj => {
    const category = obj._tytul;
    const questions = [];
    obj.wpis.forEach(q => {
      questions.push({ question: q._pyt, rate: q._stawka, answer1: q._odp1, answer2: q._odp2, answer3: q._odp3, answer4: q._odp4 });
    });
    rawData.push({ category, questions });
  });

  const newData = {
    points: 0,
    finished: false,
    data: []
  };

  let id = 0;
  rawData.forEach(quiz => {
    const category = quiz.category;
    const questions = [];
    quiz.questions.forEach(q => {
      const question = q.question;
      const rate = parseInt(q.rate);
      const answers = [];
      answers.push({ text: q.answer1, correct: true });
      answers.push({ text: q.answer2, correct: false });
      answers.push({ text: q.answer3, correct: false });
      answers.push({ text: q.answer4, correct: false });
      questions.push({ id, question, rate, correct: false, answers: shuffle(answers) });
      id++;
    });
    newData.data.push({ category, questions });
  })
  return newData;
}

export default connect(mapStateToProps)(TheWords);